export default "__VITE_ASSET__Dxkp9rdG__"